import { Component } from '@angular/core';

@Component({
  selector: 'app-installation-setup-header-actions',
  templateUrl: './installation-setup-header-actions.component.html',
  styleUrls: ['./installation-setup-header-actions.component.scss'],
})
export class InstallationSetupHeaderActionsComponent {}
